import "./OlelTermsOfUse.css";
import React from "react";

function OlelTermsOfUse() {
  return (
    <div className="OlelTermsOfUse">
      <h1 id="利用規約">利用規約</h1>
      <p>
        本利用規約（以下「本規約」と言います。）には、本サービスの提供条件及び本サービス開発者であるHiroki
        Asano（以下「当方」と言います。）とユーザーの皆様との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいたうえで、本規約に同意いただく必要があります。
      </p>
      <h2 id="第1条適用">第1条（適用）</h2>
      <ol type="1">
        <li>
          本規約は、本サービスの提供条件及び本サービスの利用に関する当方とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当方との間の本サービスの利用に関わる一切の関係に適用されます。
        </li>
        <li>
          本規約の内容と、本規約外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されるものとします。
        </li>
      </ol>
      <h2 id="第2条定義">第2条（定義）</h2>
      <p>
        本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。
      </p>
      <ol type="1">
        <li>
          「サービス利用契約」とは、本規約を契約条件として当方とユーザーの間で締結される、本サービスの利用契約を意味します。
        </li>
        <li>
          「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます。）を意味します。
        </li>
        <li>「当方」とは、本サービス開発者であるHiroki Asanoを意味します。</li>
        <li>
          「当方ウェブサイト」とは、そのドメインが「ashnoa.com」である、当方が運営するウェブサイト（理由の如何を問わず、当方のウェブサイトのドメインまたは内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。
        </li>
        <li>
          「ユーザー」とは、本規約に基づいて本サービスを利用する個人または法人を意味します。
        </li>
        <li>
          「本サービス」とは、当方が提供する「olel -
          ならびかえてつかうシンプルなメモ」（英語名称：「olel - Simple Note
          App」）という名称のサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。
        </li>
        <li>
          「アプリケーションストア」とは、Apple Inc.（Apple App
          Store）が運営・開発する、アプリケーションのデジタル配信サービスを意味します。
        </li>
        <li>
          「サブスクリプション」とは、当方がユーザーに対してサブスクリプション方式で提供するサービスをいいます。
        </li>
        <li>
          「無料トライアル」とは、サブスクリプションを購入する際に提供される可能性のある、限定的な期間中サブスクリプションに含まれる機能を無料で利用することができるサービスをいいます。
        </li>
      </ol>
      <h2 id="第3条利用開始">第3条（利用開始）</h2>
      <p>
        本サービスの利用を希望する者は、本規約を遵守することに同意することで本サービスの利用を開始することができます。
      </p>
      <h2 id="第4条サブスクリプション">第4条（サブスクリプション）</h2>
      <ol type="1">
        <li>
          本サービスの一部は、有料のサブスクリプションに加入することにより利用することができます。ユーザーはサブスクリプションの購入時に選択したプランに応じて、定期的かつ反復的に前払いでサブスクリプションの料金を支払うことにより、サブスクリプションにより提供される本サービスの一部を利用することができます。サブスクリプションはユーザーが取り消すか、その他事由により失効するかしない限り、同じ条件で自動的に更新されます。
        </li>
        <li>
          ユーザーはアプリケーションストアが定める所定の方法（https://support.apple.com/ja-jp/118428）により、サブスクリプションの更新を取り消すことができます。
        </li>
        <li>
          ユーザーはアプリケーションストアが定める所定の方法（https://support.apple.com/ja-jp/118223）により、サブスクリプションの返金をリクエストすることができます。返金の可否は、アプリケーションストアの返金ポリシーにより判断されます。
        </li>
        <li>
          当方は、当方が必要と認めた場合に、サブスクリプションの料金や内容及びその他の事項について変更できるものとします。サブスクリプション料金の変更後、ユーザーが引き続き本サービスを使用する場合、ユーザーは変更後のサブスクリプション料金の支払いに同意したものとみなします。
        </li>
        <li>
          当方は、当方が必要と認めた場合に、サブスクリプションの一定期間の無料トライアルを提供することがあります。無料トライアル終了前にユーザーがサブスクリプションを取り消さない限り、プランに応じた料金が自動的に請求され通常のサブスクリプションでの利用に移行します。
        </li>
      </ol>
      <h2 id="第5条禁止事項">第5条（禁止事項）</h2>
      <p>
        ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当方が合理的に判断する行為をしてはなりません。
      </p>
      <ol type="1">
        <li>法令に違反する行為または犯罪行為に関連する行為</li>
        <li>
          当方、本サービスの他の利用者またはその他の第三者に対する詐欺または脅迫行為
        </li>
        <li>公序良俗に反する行為</li>
        <li>
          当方、本サービスの他の利用者またはその他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害する行為
        </li>
        <li>
          本サービスを通じ、以下に該当し、または該当すると当方が合理的に判断する情報を当方または本サービスの他の利用者に送信すること
          <ul>
            <li>過度に暴力的または残虐な表現を含む情報</li>
            <li>
              コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報
            </li>
            <li>
              当方、本サービスの他の利用者またはその他の第三者の名誉または信用を毀損する表現を含む情報
            </li>
            <li>過度にわいせつな表現を含む情報</li>
            <li>差別を助長する表現を含む情報</li>
            <li>自殺、自傷行為を助長する表現を含む情報</li>
            <li>薬物の不適切な利用を助長する表現を含む情報</li>
            <li>反社会的な表現を含む情報</li>
            <li>チェーンメール等の第三者への情報の拡散を求める情報</li>
            <li>他人に不快感を与える表現を含む情報</li>
          </ul>
        </li>
        <li>
          本サービスのネットワークまたはシステム等に過度な負荷をかける行為
        </li>
        <li>
          当方が提供するソフトウェアその他のシステムに対するリバースエンジニアリングその他の解析行為
        </li>
        <li>本サービスの運営を妨害するおそれのある行為</li>
        <li>当方のネットワークまたはシステム等への不正アクセス</li>
        <li>本サービスの他の利用者の情報の収集</li>
        <li>
          当方、本サービスの他の利用者またはその他の第三者に不利益、損害、不快感を与える行為
        </li>
        <li>反社会的勢力等への利益供与</li>
        <li>前各号の行為を直接または間接に惹起し、または容易にする行為</li>
        <li>前各号の行為を試みること</li>
        <li>その他、当方が不適切であると合理的に判断する行為</li>
      </ol>
      <h2 id="第6条権利帰属">第6条（権利帰属）</h2>
      <p>
        当方ウェブサイト及び本サービスに関する知的財産権は全て当方または当方にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、当方ウェブサイトまたは本サービスに関する当方または当方にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
      </p>
      <h2 id="第7条本サービスの内容の変更一時停止終了">
        第7条（本サービスの内容の変更・一時停止・終了）
      </h2>
      <p>
        当方は、当方の都合により、本サービスの内容を変更し、または提供を一時停止・終了することができます。
      </p>
      <h2 id="第8条保証の否認及び免責">第8条（保証の否認及び免責）</h2>
      <ol type="1">
        <li>
          当方は、本サービスがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利または利益を侵害しないこと、継続的に利用できること、及び不具合が生じないことについて、明示または黙示を問わず何ら保証するものではありません。
        </li>
        <li>
          当方は、当方に故意または重過失がある場合を除き、本サービスに関してユーザーが被った損害につき、過去12ヶ月間にユーザーが当方に支払った対価の金額を超えて賠償する責任を負わないものとします。
        </li>
        <li>
          本サービスまたは当方ウェブサイトに関連してユーザーと他のユーザーまたは第三者との間において生じた取引、連絡、紛争等については、ユーザーが自己の責任によって解決するものとします。
        </li>
      </ol>
      <h2 id="第9条秘密保持">第9条（秘密保持）</h2>
      <p>
        ユーザーは、本サービスに関連して当方がユーザーに対して秘密に取扱うことを求めて開示した非公知の情報について、当方の事前の書面による承諾がある場合を除き、秘密に取扱うものとします。
      </p>
      <h2 id="第10条利用者情報の取扱い">第10条（利用者情報の取扱い）</h2>
      <ol type="1">
        <li>
          当方によるユーザーの利用者情報の取扱いについては、別途プライバシーポリシー（https://ashnoa.com/#/olel/privacy-policy）の定めによるものとし、ユーザーはこのプライバシーポリシーに従って当方がユーザーの利用者情報を取扱うことについて同意するものとします。
        </li>
        <li>
          当方は、ユーザーが当方に提供した情報、データ等を、個人を特定できない形での統計的な情報として、当方の裁量で、利用及び公開することができるものとし、ユーザーはこれに異議を唱えないものとします。
        </li>
      </ol>
      <h2 id="第11条本規約等の変更">第11条（本規約等の変更）</h2>
      <ol type="1">
        <li>
          当方は、当方が必要と認めた場合に、本規約を変更できるものとします。
        </li>
        <li>
          本規約を変更する場合、変更後の本規約の施行時期及び内容を当方ウェブサイト上での掲示その他の適切な方法により周知し、またはユーザーに通知します。
        </li>
      </ol>
      <h2 id="第12条連絡通知">第12条（連絡／通知）</h2>
      <ol type="1">
        <li>
          本サービスに関する問い合わせその他ユーザーから当方に対する連絡または通知、及び本規約の変更に関する通知その他当方からユーザーに対する連絡または通知は、当方の定める方法で行うものとします。
        </li>
        <li>
          当方がメールアドレスその他の連絡先に連絡または通知を行った場合、ユーザーは当該連絡または通知を受領したものとみなします。
        </li>
      </ol>
      <h2 id="第13条サービス利用契約上の地位の譲渡等">
        第13条（サービス利用契約上の地位の譲渡等）
      </h2>
      <ol type="1">
        <li>
          ユーザーは、当方の書面による事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
        </li>
        <li>
          当方は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びにユーザーの利用者情報その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
        </li>
      </ol>
      <h2 id="第14条分離可能性">第14条（分離可能性）</h2>
      <p>
        本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
      </p>
      <h2 id="第15条準拠法及び裁判管轄">第15条（準拠法及び裁判管轄）</h2>
      <ol type="1">
        <li>本規約及びサービス利用契約の準拠法は日本法とします。</li>
        <li>
          本規約またはサービス利用契約に起因し、または関連する一切の紛争については、仙台地方裁判所を第一審の専属的合意管轄裁判所とします。
        </li>
      </ol>
      <p>【2024年12月8日制定】</p>
      <p>【2025年1月11日改定】</p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}

export default OlelTermsOfUse;
